<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">

      <el-form-item label="文本">
        <el-input v-model="formData.text"></el-input>
      </el-form-item>
      <el-form-item label="附件">

        <el-input type="textarea" :rows="2" v-model="formData.files"></el-input>
      </el-form-item>

      <el-form-item  label="更新状态">
        <el-input type="textarea" v-model="formData.upstate"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import * as flowUtil from '@/utils/logicFlowJs.js';
export default {
  name: '',
  props: {
    nodeData: Object,
    setData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },
    setData: {
      handler(n, o) {
        this.flowSetData= n;

      },
      deep:true// 深度监听父组件传过来对象变化
    },
  },
  mounted() {
    const { properties,text } = this.$props.nodeData
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
    }
    if (text && text.value) {
      this.$data.formData.text = text.value
    }
    this.flowSetData=this.$props.setData;

  },
  data() {
    return {
      formData: {
        text:'开始',
        files:'',
        upstate:'',
      },

      flowSetData:{},
    }
  },

  methods: {

  }
}
</script>
<style scoped>
  .feild {
    height: 20px;
    width:100%;
    line-height: 20px;
    font-size: 10px;
    display: flex;
    border: none;
    padding: 0 0px;
  }
  .button {
    height: 20px;
    width:20px;
    line-height: 25px;
    font-size: 8px;
    display: flex;
    border: none;
    padding: 5px;
  }
</style>
